import React from 'react'
import type { CopySegment } from 'src/util/dunningCopy'

/**
 * Renders the segmented dunning copy, bolding the segments marked for emphasis (ENG-1532) — the
 * deadline date and the charge amount, per the Figma.
 *
 * One renderer shared by the dialog and the header banner, so the two cannot end up emphasising
 * different things.
 */
export default function DunningCopyText({ segments }: { segments: CopySegment[] }) {
  return (
    <>
      {segments.map((segment, index) =>
        segment.bold ? (
          <strong key={index}>{segment.text}</strong>
        ) : (
          <React.Fragment key={index}>{segment.text}</React.Fragment>
        )
      )}
    </>
  )
}
